<template>
  <div class="page-content">
    <div class="denglv-content">
      <img class="banner" src="../assets/images/denglv-img.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "OneStopServiceHome"
}
</script>

<style scoped>
.banner{
  height: calc(100vh - 178px);
}
.denglv-content {
  width: 100%;
  min-height: calc(100vh - 280px);
  margin: 0px auto 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
